// German for the poll hook's one visible line.
import { registerDe } from '../i18n/index.js';

registerDe({
  'data updated {time} · reconnecting': 'Stand {time} · Verbindung wird wiederhergestellt',
}, 'usePoll');
